<span class="status-badge" [ngClass]="getStatusClass()">
  {{ status | titlecase }}
</span>